<div class="question-view__heatmap-header">
  <span class="question-view__heatmap-header-title fs__sm">
    @if (question.minLength > 0 && question.maxLength > 0) {
      {{ 'system.heatmap.minMaxAreas' | translate: { min: question.minLength, max: question.maxLength } }}
    } @else if (question.minLength > 0) {
      {{ 'system.heatmap.minAreas' | translate: { min: question.minLength } }}
    } @else if (question.maxLength > 0) {
      {{ 'system.heatmap.maxAreas' | translate: { max: question.maxLength } }}
    }
  </span>
  <button mat-stroked-button (click)="onClear()">
    <fa-icon [icon]="faArrowsRotate"></fa-icon>
    {{ 'system.heatmap.clear' | translate }}
  </button>
</div>

<div id="heatmapContainer" [style.height]="question.imageHeight + 'px'" [style.width]="question.imageWidth + 'px'">
  <div class="overlay" [style.background-image]="mediaUrl$ | async" [style.background-size]="question.imageFit"></div>
</div>
